//
//
//
import vueAxios from './vueAxios';
import {
  numberToWords,
} from "@persian-tools/persian-tools";
// import myDate from '../functions/myDate'

export default async function retrieveInvoiceData(invoice_mid) {
  if (!invoice_mid) return
  //
  try {
    const res = await vueAxios.get('/invoices/print', {
      params: {
        mid: invoice_mid
      },
    })
    if (res?.invoice && res?.invoicePrice && res?.invoiceTotal) {
      res.invoice.invoice_date = new Date(res.invoice.create_date).getTime() // for label
      res.invoice.total = res.invoiceTotal
      res.invoice.price = res.invoicePrice
      res.invoice.priceInWords = numberToWords(res.invoicePrice)
      // res.invoice.create_date = myDate.toJalaali(res.invoice.create_date).date
      // res.invoice.items.forEach((item) => {
      //   if (item.second_value) item.price = (item.price * item.product_id.n).toFixed(0)
      // })
      return res.invoice
    } else {
      return []
    }
  } catch (e) {
    console.error(e)
  } finally {
    // this.loading = false
  }
}
